import React from 'react';
import commonRefHOC from '../../commonRefHOC';
import {InputNumber} from "antd";

export default commonRefHOC(InputNumber);